const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCnhCategoria: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'VEICULO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VEICULO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'VEICULO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.placa,
                    id_transportadora: item.id_transportadora,
                    id_motorista: item.id_motorista
                }))
            };

        case 'VEICULO_CNH_CATEGORIA_LISTADO':
                 
			return { ...state, listaCnhCategoria: action.payload.data };

        default:
            return state;
    }
}
